export class ReturnRequestExcelDto {
    comment: string;
    requestQuantity: number;
    sizeName: string;
    storeOriginCode: string;
    styleVariety: string;
}